import * as time from '@/utils/time.ts';

export const PURGE_ALL_ENDPOINTS = '__all__';
export const CACHE_TTL = 60 * time.second;
